import React, { useEffect, useState } from 'react';
const LoadingText = ({ text }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            setCurrentIndex((currentIndex + 1) % text.length);
        }, 3000);
        return () => clearTimeout(timer);
    }, [currentIndex, text.length]);
    return (React.createElement("div", { className: "hg-modal__loading-text" }, text.map((text, index) => (React.createElement("h3", { key: index, className: index === currentIndex ? 'visible' : '' }, text)))));
};
export default LoadingText;
